import {
  EXTENSION_FORMAT_7Z, EXTENSION_FORMAT_ACCDA, EXTENSION_FORMAT_ACCDB, EXTENSION_FORMAT_ACCDE, EXTENSION_FORMAT_ACCDR,
  EXTENSION_FORMAT_ACCDT, EXTENSION_FORMAT_ADE, EXTENSION_FORMAT_ADN, EXTENSION_FORMAT_ADP, EXTENSION_FORMAT_ARC,
  EXTENSION_FORMAT_BMP, EXTENSION_FORMAT_BZ, EXTENSION_FORMAT_BZ2, EXTENSION_FORMAT_CALCX, EXTENSION_FORMAT_CSV,
  EXTENSION_FORMAT_DBF, EXTENSION_FORMAT_DIF, EXTENSION_FORMAT_DOC, EXTENSION_FORMAT_DOCM, EXTENSION_FORMAT_DOCX,
  EXTENSION_FORMAT_DOT, EXTENSION_FORMAT_DOTM, EXTENSION_FORMAT_DOTX, EXTENSION_FORMAT_EMF, EXTENSION_FORMAT_GIF,
  EXTENSION_FORMAT_HTM, EXTENSION_FORMAT_HTML, EXTENSION_FORMAT_ICO, EXTENSION_FORMAT_JPEG, EXTENSION_FORMAT_JPG,
  EXTENSION_FORMAT_JSON, EXTENSION_FORMAT_MDB, EXTENSION_FORMAT_MDE, EXTENSION_FORMAT_MDF, EXTENSION_FORMAT_MDN,
  EXTENSION_FORMAT_MDT, EXTENSION_FORMAT_MDW, EXTENSION_FORMAT_MHT, EXTENSION_FORMAT_MHTML, EXTENSION_FORMAT_MPP,
  EXTENSION_FORMAT_ODP, EXTENSION_FORMAT_ODS, EXTENSION_FORMAT_ODT, EXTENSION_FORMAT_PBIT, EXTENSION_FORMAT_PBIX,
  EXTENSION_FORMAT_PDF, EXTENSION_FORMAT_PNG, EXTENSION_FORMAT_POT, EXTENSION_FORMAT_POTM, EXTENSION_FORMAT_POTX,
  EXTENSION_FORMAT_PPA, EXTENSION_FORMAT_PPAM, EXTENSION_FORMAT_PPS, EXTENSION_FORMAT_PPSM, EXTENSION_FORMAT_PPSX,
  EXTENSION_FORMAT_PPT, EXTENSION_FORMAT_PPTM, EXTENSION_FORMAT_PPTX, EXTENSION_FORMAT_RAR, EXTENSION_FORMAT_RTF,
  EXTENSION_FORMAT_SLK, EXTENSION_FORMAT_SVG, EXTENSION_FORMAT_TAR, EXTENSION_FORMAT_THMX, EXTENSION_FORMAT_TIF,
  EXTENSION_FORMAT_TIFF, EXTENSION_FORMAT_TXT, EXTENSION_FORMAT_W6W, EXTENSION_FORMAT_WEBP, EXTENSION_FORMAT_WMF,
  EXTENSION_FORMAT_WORD, EXTENSION_FORMAT_WPS, EXTENSION_FORMAT_WRI, EXTENSION_FORMAT_XHTML, EXTENSION_FORMAT_XLA,
  EXTENSION_FORMAT_XLAM, EXTENSION_FORMAT_XLS, EXTENSION_FORMAT_XLSB, EXTENSION_FORMAT_XLSM, EXTENSION_FORMAT_XLSX,
  EXTENSION_FORMAT_XLT, EXTENSION_FORMAT_XLTM, EXTENSION_FORMAT_XLTX, EXTENSION_FORMAT_XLW, EXTENSION_FORMAT_XML,
  EXTENSION_FORMAT_XPS, EXTENSION_FORMAT_ZIP,
} from '../constants/system/extension-formats';
import {
  MIME_TYPE_APPLICATION_DBF, MIME_TYPE_APPLICATION_JSON, MIME_TYPE_APPLICATION_MS_EXCEL,
  MIME_TYPE_APPLICATION_MS_POWERPOINT, MIME_TYPE_APPLICATION_MSACCESS, MIME_TYPE_APPLICATION_MSPROJECT,
  MIME_TYPE_APPLICATION_MSWORD, MIME_TYPE_APPLICATION_MSWRITE, MIME_TYPE_APPLICATION_OXPS, MIME_TYPE_APPLICATION_PBIT,
  MIME_TYPE_APPLICATION_PBIX, MIME_TYPE_APPLICATION_PDF, MIME_TYPE_APPLICATION_RTF, MIME_TYPE_APPLICATION_VND_MS_EXCEL,
  MIME_TYPE_APPLICATION_VND_MS_EXCEL_ADDIN_MACRO_ENABLED, MIME_TYPE_APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACRO_ENABLED,
  MIME_TYPE_APPLICATION_VND_MS_EXCEL_SHEET_MACRO_ENABLED, MIME_TYPE_APPLICATION_VND_MS_EXCEL_TEMPLATE_MACRO_ENABLED,
  MIME_TYPE_APPLICATION_VND_MS_OFFICE_CALX, MIME_TYPE_APPLICATION_VND_MS_OFFICETHEME,
  MIME_TYPE_APPLICATION_VND_MS_POWERPOINT, MIME_TYPE_APPLICATION_VND_MS_POWERPOINT_ADDIN_MACRO_ENABLED,
  MIME_TYPE_APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACRO_ENABLED,
  MIME_TYPE_APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACRO_ENABLED,
  MIME_TYPE_APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACRO_ENABLED,
  MIME_TYPE_APPLICATION_VND_MS_WORKS, MIME_TYPE_APPLICATION_VND_MS_XPS_DOCUMENT,
  MIME_TYPE_APPLICATION_VND_MSWORD_DOCUMENT_MACRO_ENABLED, MIME_TYPE_APPLICATION_VND_MSWORD_TEMPLATE_MACRO_ENABLED,
  MIME_TYPE_APPLICATION_VND_OPENDOCUMENT_PRESENTATION, MIME_TYPE_APPLICATION_VND_OPENDOCUMENT_SPREADSHEET,
  MIME_TYPE_APPLICATION_VND_OPENDOCUMENT_TEXT, MIME_TYPE_APPLICATION_VND_OPENXML_PRESENTATIONML_PRESENTATION,
  MIME_TYPE_APPLICATION_VND_OPENXML_PRESENTATIONML_SLIDESHOW, MIME_TYPE_APPLICATION_VND_OPENXML_PRESENTATIONML_TEMPLATE,
  MIME_TYPE_APPLICATION_VND_OPENXML_SPREADSHEET_SHEET, MIME_TYPE_APPLICATION_VND_OPENXML_SPREADSHEET_TEMPLATE,
  MIME_TYPE_APPLICATION_VND_OPENXML_WORD_DOCUMENT, MIME_TYPE_APPLICATION_VND_OPENXML_WORD_TEMPLATE,
  MIME_TYPE_APPLICATION_VND_RAR, MIME_TYPE_APPLICATION_VND_X_BZIP, MIME_TYPE_APPLICATION_VND_X_BZIP2,
  MIME_TYPE_APPLICATION_VND_X_FREEARC, MIME_TYPE_APPLICATION_X_7Z_COMPRESSED, MIME_TYPE_APPLICATION_X_DIF,
  MIME_TYPE_APPLICATION_X_MIMEARCHIVE, MIME_TYPE_APPLICATION_X_MS_WORKS_WP, MIME_TYPE_APPLICATION_X_SYLK,
  MIME_TYPE_APPLICATION_X_TAR, MIME_TYPE_APPLICATION_XHTML_XML, MIME_TYPE_APPLICATION_XML, MIME_TYPE_APPLICATION_ZIP,
  MIME_TYPE_IMAGE_BMP, MIME_TYPE_IMAGE_EMF, MIME_TYPE_IMAGE_GIF, MIME_TYPE_IMAGE_JPEG, MIME_TYPE_IMAGE_JPG,
  MIME_TYPE_IMAGE_PNG, MIME_TYPE_IMAGE_SVG_XML, MIME_TYPE_IMAGE_TIFF, MIME_TYPE_IMAGE_VND_MICROSOFT_ICON,
  MIME_TYPE_IMAGE_WEBP, MIME_TYPE_IMAGE_WMF, MIME_TYPE_TEXT_COMMA_SEPARATED_VALUES, MIME_TYPE_TEXT_CSV,
  MIME_TYPE_TEXT_HTML, MIME_TYPE_TEXT_MESSAGE_RFC822, MIME_TYPE_TEXT_MULTIPART_RELATED, MIME_TYPE_TEXT_PLAIN,
  MIME_TYPE_TEXT_XML,
} from '../constants/system/mime-types';
import {
  REGEXP_TEMPLATE_FILE_EXTENSION, REGEXP_TEMPLATE_HAS_DOT,
} from '../constants/system/regexp-templates';

export default class FileService {
  public static EXTENSION_MIME_TYPE_MAP: Record<string, string[]> = {
    [MIME_TYPE_IMAGE_PNG]: [EXTENSION_FORMAT_PNG],
    [MIME_TYPE_IMAGE_JPEG]: [EXTENSION_FORMAT_JPEG],
    [MIME_TYPE_IMAGE_JPG]: [EXTENSION_FORMAT_JPG],
    [MIME_TYPE_IMAGE_GIF]: [EXTENSION_FORMAT_GIF],
    [MIME_TYPE_IMAGE_BMP]: [EXTENSION_FORMAT_BMP],
    [MIME_TYPE_IMAGE_WEBP]: [EXTENSION_FORMAT_WEBP],
    [MIME_TYPE_IMAGE_TIFF]: [EXTENSION_FORMAT_TIF, EXTENSION_FORMAT_TIFF],
    [MIME_TYPE_IMAGE_WMF]: [EXTENSION_FORMAT_WMF],
    [MIME_TYPE_IMAGE_EMF]: [EXTENSION_FORMAT_EMF],
    [MIME_TYPE_IMAGE_SVG_XML]: [EXTENSION_FORMAT_SVG],
    [MIME_TYPE_IMAGE_VND_MICROSOFT_ICON]: [EXTENSION_FORMAT_ICO],
    [MIME_TYPE_TEXT_CSV]: [EXTENSION_FORMAT_CSV],
    [MIME_TYPE_TEXT_COMMA_SEPARATED_VALUES]: [EXTENSION_FORMAT_CSV],
    [MIME_TYPE_TEXT_HTML]: [EXTENSION_FORMAT_HTML, EXTENSION_FORMAT_HTM],
    [MIME_TYPE_TEXT_XML]: [EXTENSION_FORMAT_XML],
    [MIME_TYPE_TEXT_MESSAGE_RFC822]: [EXTENSION_FORMAT_MHT],
    [MIME_TYPE_TEXT_MULTIPART_RELATED]: [EXTENSION_FORMAT_MHTML],
    [MIME_TYPE_APPLICATION_X_MIMEARCHIVE]: [EXTENSION_FORMAT_MHTML],
    [MIME_TYPE_TEXT_PLAIN]: [EXTENSION_FORMAT_TXT],
    [MIME_TYPE_APPLICATION_JSON]: [EXTENSION_FORMAT_JSON],
    [MIME_TYPE_APPLICATION_PDF]: [EXTENSION_FORMAT_PDF],
    [MIME_TYPE_APPLICATION_MS_EXCEL]: [EXTENSION_FORMAT_XLS, EXTENSION_FORMAT_XLT,
      EXTENSION_FORMAT_XLA, EXTENSION_FORMAT_XLW],
    [MIME_TYPE_APPLICATION_VND_MS_EXCEL]: [EXTENSION_FORMAT_XLS, EXTENSION_FORMAT_CSV],
    [MIME_TYPE_APPLICATION_VND_OPENXML_SPREADSHEET_SHEET]: [EXTENSION_FORMAT_XLSX],
    [MIME_TYPE_APPLICATION_VND_OPENXML_SPREADSHEET_TEMPLATE]: [EXTENSION_FORMAT_XLTX],
    [MIME_TYPE_APPLICATION_VND_MS_EXCEL_SHEET_MACRO_ENABLED]: [EXTENSION_FORMAT_XLSM],
    [MIME_TYPE_APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACRO_ENABLED]: [EXTENSION_FORMAT_XLSB],
    [MIME_TYPE_APPLICATION_VND_MS_EXCEL_TEMPLATE_MACRO_ENABLED]: [EXTENSION_FORMAT_XLTM],
    [MIME_TYPE_APPLICATION_VND_MS_EXCEL_ADDIN_MACRO_ENABLED]: [EXTENSION_FORMAT_XLAM],
    [MIME_TYPE_APPLICATION_MSWORD]: [EXTENSION_FORMAT_DOC, EXTENSION_FORMAT_DOT,
      EXTENSION_FORMAT_WORD, EXTENSION_FORMAT_W6W],
    [MIME_TYPE_APPLICATION_VND_MSWORD_DOCUMENT_MACRO_ENABLED]: [EXTENSION_FORMAT_DOCM],
    [MIME_TYPE_APPLICATION_VND_OPENXML_WORD_DOCUMENT]: [EXTENSION_FORMAT_DOCX],
    [MIME_TYPE_APPLICATION_VND_OPENXML_WORD_TEMPLATE]: [EXTENSION_FORMAT_DOTX],
    [MIME_TYPE_APPLICATION_VND_MSWORD_TEMPLATE_MACRO_ENABLED]: [EXTENSION_FORMAT_DOTM],
    [MIME_TYPE_APPLICATION_VND_MS_POWERPOINT]: [EXTENSION_FORMAT_PPT],
    [MIME_TYPE_APPLICATION_VND_OPENXML_PRESENTATIONML_PRESENTATION]: [EXTENSION_FORMAT_PPTX],
    [MIME_TYPE_APPLICATION_MS_POWERPOINT]: [EXTENSION_FORMAT_PPT, EXTENSION_FORMAT_POT,
      EXTENSION_FORMAT_PPS, EXTENSION_FORMAT_PPA],
    [MIME_TYPE_APPLICATION_VND_OPENXML_PRESENTATIONML_TEMPLATE]: [EXTENSION_FORMAT_POTX],
    [MIME_TYPE_APPLICATION_VND_OPENXML_PRESENTATIONML_SLIDESHOW]: [EXTENSION_FORMAT_PPSX],
    [MIME_TYPE_APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACRO_ENABLED]: [EXTENSION_FORMAT_PPTM],
    [MIME_TYPE_APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACRO_ENABLED]: [EXTENSION_FORMAT_PPSM],
    [MIME_TYPE_APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACRO_ENABLED]: [EXTENSION_FORMAT_POTM],
    [MIME_TYPE_APPLICATION_VND_MS_POWERPOINT_ADDIN_MACRO_ENABLED]: [EXTENSION_FORMAT_PPAM],
    [MIME_TYPE_APPLICATION_MSACCESS]: [
      EXTENSION_FORMAT_MDB, EXTENSION_FORMAT_ACCDA, EXTENSION_FORMAT_ACCDB, EXTENSION_FORMAT_ACCDE,
      EXTENSION_FORMAT_ACCDR, EXTENSION_FORMAT_ACCDT, EXTENSION_FORMAT_ADE, EXTENSION_FORMAT_ADP,
      EXTENSION_FORMAT_ADN, EXTENSION_FORMAT_MDE, EXTENSION_FORMAT_MDF, EXTENSION_FORMAT_MDN, EXTENSION_FORMAT_MDT,
      EXTENSION_FORMAT_MDW,
    ],
    [MIME_TYPE_APPLICATION_VND_MS_OFFICE_CALX]: [EXTENSION_FORMAT_CALCX],
    [MIME_TYPE_APPLICATION_MSPROJECT]: [EXTENSION_FORMAT_MPP],
    [MIME_TYPE_APPLICATION_PBIT]: [EXTENSION_FORMAT_PBIT],
    [MIME_TYPE_APPLICATION_PBIX]: [EXTENSION_FORMAT_PBIX],
    [MIME_TYPE_APPLICATION_MSWRITE]: [EXTENSION_FORMAT_WRI],
    [MIME_TYPE_APPLICATION_VND_MS_WORKS]: [EXTENSION_FORMAT_WPS],
    [MIME_TYPE_APPLICATION_X_MS_WORKS_WP]: [EXTENSION_FORMAT_WPS],
    [MIME_TYPE_APPLICATION_VND_MS_XPS_DOCUMENT]: [EXTENSION_FORMAT_XPS],
    [MIME_TYPE_APPLICATION_OXPS]: [EXTENSION_FORMAT_XPS],
    [MIME_TYPE_APPLICATION_DBF]: [EXTENSION_FORMAT_DBF],
    [MIME_TYPE_APPLICATION_X_DIF]: [EXTENSION_FORMAT_DIF],
    [MIME_TYPE_APPLICATION_X_SYLK]: [EXTENSION_FORMAT_SLK],
    [MIME_TYPE_APPLICATION_VND_MS_OFFICETHEME]: [EXTENSION_FORMAT_THMX],
    [MIME_TYPE_APPLICATION_X_7Z_COMPRESSED]: [EXTENSION_FORMAT_7Z],
    [MIME_TYPE_APPLICATION_ZIP]: [EXTENSION_FORMAT_ZIP],
    [MIME_TYPE_APPLICATION_XML]: [EXTENSION_FORMAT_XML],
    [MIME_TYPE_APPLICATION_XHTML_XML]: [EXTENSION_FORMAT_XHTML],
    [MIME_TYPE_APPLICATION_X_TAR]: [EXTENSION_FORMAT_TAR],
    [MIME_TYPE_APPLICATION_RTF]: [EXTENSION_FORMAT_RTF],
    [MIME_TYPE_APPLICATION_VND_RAR]: [EXTENSION_FORMAT_RAR],
    [MIME_TYPE_APPLICATION_VND_OPENDOCUMENT_TEXT]: [EXTENSION_FORMAT_ODT],
    [MIME_TYPE_APPLICATION_VND_OPENDOCUMENT_SPREADSHEET]: [EXTENSION_FORMAT_ODS],
    [MIME_TYPE_APPLICATION_VND_OPENDOCUMENT_PRESENTATION]: [EXTENSION_FORMAT_ODP],
    [MIME_TYPE_APPLICATION_VND_X_BZIP]: [EXTENSION_FORMAT_BZ],
    [MIME_TYPE_APPLICATION_VND_X_BZIP2]: [EXTENSION_FORMAT_BZ2],
    [MIME_TYPE_APPLICATION_VND_X_FREEARC]: [EXTENSION_FORMAT_ARC],
  };

  public static checkFileExtension(file: File, acceptedExtensionList: string[]): boolean {
    if (!file.type) {
      if (file.type === '') {
        const extensionList: string[] = Object.values(this.EXTENSION_MIME_TYPE_MAP).flat();
        const fileExtension: string = this.getFileExtensionByName(file.name);

        if (!fileExtension) {
          return false;
        }

        return !!extensionList.find((extension: string): boolean => extension === fileExtension);
      }

      return false;
    }

    if (!Object.keys(this.EXTENSION_MIME_TYPE_MAP).find((type: string): boolean => type === file.type)) {
      return false;
    }

    const extensions: string[] = this.EXTENSION_MIME_TYPE_MAP[file.type];
    if (!acceptedExtensionList || !acceptedExtensionList.length || !extensions || !extensions.length) {
      return true;
    }

    for (let extensionIndex: number = 0; extensionIndex < extensions.length; extensionIndex++) {
      const extension: string = extensions[extensionIndex];

      if (acceptedExtensionList.includes(extension)) {
        return true;
      }
    }

    return false;
  }

  public static getFileExtensionByName(fileName: string): string {
    const templateHasDot: RegExp = new RegExp(REGEXP_TEMPLATE_HAS_DOT);
    const templateFileExtension: RegExp = new RegExp(REGEXP_TEMPLATE_FILE_EXTENSION);

    if (!fileName) {
      return '';
    }

    if (!templateHasDot.exec(fileName)) {
      return '';
    }

    const extension: RegExpExecArray | null = templateFileExtension.exec(fileName);
    if (!extension) {
      return '';
    }

    return extension.toString().toLowerCase();
  }

  public static createFileLink(file: Blob): string {
    return URL.createObjectURL(file);
  }
}
